<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      rolePathArray:'',
    }
  },
  created(){  //载入前
    localStorage.setItem("windowWidth", document.documentElement.clientWidth)
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }
 
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    if(localStorage.token && localStorage.user){
      this.rolePathArray = JSON.parse(localStorage.user).rolePathArray
      if(document.documentElement.clientWidth < 768){
        this.$alert('请用电脑访问系统', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push({path:'/login'})
          }
        });
        return
        //移动端业务
        let webShowPathDatas = [//移动端的所有页面
          {path:'/student/signup/physician',name:'报名审核(医师医技)',icon:'el-icon--yiliao-yisheng'},
          {path:'/student/signup/nursing',name:'报名审核(护理)',icon:'el-icon-hushi'},
          {path:'/student/checkin',name:'报到审核',icon:'el-icon-bumenbaodao'},
          {path:'/student/graduation/physician',name:'结业审核(医师医技)',icon:'el-icon-biyeguanli'},
          {path:'/student/graduation/nursing',name:'结业审核(护理)',icon:'el-icon-biyeguanli'},
          {path:'/student/assignTeacher',name:'分配指导老师',icon:'el-icon-fenpei'},
          // {path:'/student/jointApproval',name:'结业联合审核',icon:'el-icon-duogeyonghu'},
          {path:'/jointApproval/zkzxApproval',name:'制卡中心审核',icon:'el-icon-duogeyonghu'},
          {path:'/jointApproval/tsgApproval',name:'图书馆审核',icon:'el-icon-duogeyonghu'},
          {path:'/admin/schoolCompanyApply',name:'学校/单位审核',icon:'el-icon-shenhe'},
        ]
        let web_rolePathArray = []//根据当前账号匹配出移动端能看到的页面
        webShowPathDatas.forEach((element,index) => {
            if(this.rolePathArray.indexOf(element.path) !== -1){
                web_rolePathArray.push(element)
            }
        });
        localStorage.setItem("web_rolePathArray", JSON.stringify(web_rolePathArray))
        this.$router.push({ path:'/web/room/index' })
      }else{
        // if(localStorage.user.firstLogin == 0){
        //     this.$router.push({path:'/changepassword'})
        // }else{
        //     this.$router.push({ path:this.rolePathArray[0] })
        // }
      }
    }else{
      this.$router.push({path:'/login'})
    }
  },
  methods: {
    //页面刷新
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted(){
    
  }
}
</script>

<style lang='scss'>
$backgrund: blue;
*{
  box-sizing: border-box;
  margin: 0;
}
#app{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
width:8px !important;
height: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0) !important;
border-radius:10px !important;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
border-radius:6px !important;
background:rgba(0,0,0,0.1) !important;
-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.5) !important;
}
::-webkit-scrollbar-thumb:window-inactive {
background:rgba(0,0,0,0.2) !important;
}




// @media only screen and (max-width: 768px) {
//   body {
//   position: fixed;
//   width: 100%;
//   height: 100%;
//   padding: 0;
//   margin: 0;
//   overflow: hidden;
// }
 
 
//   #app {
//     position: absolute;
//     width: 100vh;
//     height: 100vw;
//     top: 0;
//     left: 100vw;
//     -webkit-transform: rotate(90deg);
//     -moz-transform: rotate(90deg);
//     -ms-transform: rotate(90deg);
//     transform: rotate(90deg);
//     transform-origin: 0% 0%;
//   }
//   .main{
//     width: 100vh !important;
//     height: 100vw !important;
//   }
//   .homeMain{
//     width: 100vh !important;
//     height: 100vw !important;
//   }
//   .homeMain .right{
//     width: calc(100vh - 200px) !important;
//   }
//   .homeMain .content{
//     max-width: calc(100vh - 200px) !important;
//     max-height: calc(100vw - 60px) !important;
//   }
// }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/App.vue